(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ln-desktop-open]').forEach(details => {
      if (details.dataset.responsiveReady) return;
      details.dataset.responsiveReady = 'true';
      const mobile = matchMedia('(max-width: 600px)');
      const sync = () => {
        details.open = !mobile.matches;
        details.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
      };
      sync();
      mobile.addEventListener('change', sync);
    });
    scope.querySelectorAll('.lnh__phone-services').forEach(controls => {
      const mobile = matchMedia('(max-width: 600px)');
      const sync = () => { controls.inert = mobile.matches; controls.setAttribute('aria-hidden', String(mobile.matches)); };
      sync(); mobile.addEventListener('change', sync);
    });
    scope.querySelectorAll('[data-ln-marquee-pause]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const paused = button.closest('.ln-marquee').classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Logoanimatie hervatten' : 'Logoanimatie pauzeren');
        button.textContent = paused ? 'Hervatten' : 'Pauzeren';
      });
    });
    scope.querySelectorAll('.ln-marquee').forEach(strip => {
      if (strip.dataset.motionReady) return;
      strip.dataset.motionReady = 'true';
      let visible = false, heroVisible = false;
      const sync = () => {
        strip.classList.toggle('is-outside', !visible || document.hidden);
        strip.classList.toggle('is-secondary-motion', heroVisible);
      };
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
      observer.observe(strip);
      const hero = document.querySelector('.lnh');
      if (hero) {
        const heroObserver = new IntersectionObserver(entries => { heroVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .55; sync(); }, {threshold: [0, .55]});
        heroObserver.observe(hero);
      }
      document.addEventListener('visibilitychange', sync);
      sync();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
